import {
  CUSTOMER_TYPE,
  CustomerType,
} from '../../../shared/constants/customer/customerType';
import { ScanService } from './types';
import { nutritionScanService } from './nutritionScanService';
import { scanIqScanService } from './scanIqScanService';

export const getScanService = (customerType: CustomerType): ScanService => {
  const services = {
    [CUSTOMER_TYPE.NUTRITION]: nutritionScanService,
    [CUSTOMER_TYPE.SCAN_IQ]: scanIqScanService,
  };
  return services[customerType];
};
